// TODO: 16 得有个统一配置的地方
export const rem = (px: number) => px / 16;
